'use strict';

export const CLASS_NAME = 'TeamRoleDomain';

export function TeamRoleDomainProvider() {
  return {
    $get: ['FirebaseUtil', 'AbstractRelationClass', '$injector',
      function (FirebaseUtil, AbstractRelationClass, $injector) {
        function TeamRoleDomain(data) {
          AbstractRelationClass.call(this, TeamRoleDomain, data);
        }

        AbstractRelationClass.__inheritFrom(TeamRoleDomain, CLASS_NAME);

        TeamRoleDomain.$constraints.addConstraints({
          name: {type: 'string'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'}
        });

        TeamRoleDomain.prototype.toString = function () {
          return this.name;
        };

        return TeamRoleDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/personnel/domain/TeamRoleDomain.js